import { usePropertyLandSizeQuantity, usePropertyLandSizeUnit } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { NumberBox, DropDownBox, DropDownBoxComponentSpacing } from '@apply/components';
import * as Store from '@apply/store';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface LandSizeProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const LandSize: React.FC<LandSizeProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Land Size';
    const [landSizeQuantity, set_landSizeQuantity] = usePropertyLandSizeQuantity(propertyGuid);
    const [landSizeUnit, set_landSizeUnit] = usePropertyLandSizeUnit(propertyGuid);

    const landSizeUnits = [
        { display: '', value: '' },
        ...Store.PropertiesStore.Types.LandSizeUnit.map((st) => {
            return {
                display: st.toString(),
                value: st.toString(),
            };
        }),
    ];

    const applicationQuestionReviewItemValue = () => {
        if (landSizeQuantity && landSizeQuantity != '' && landSizeQuantity != '0') {
            return `${Number(landSizeQuantity).toLocaleString('en-US')} ${landSizeUnit}`;
        } else {
            return 'Not Provided';
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={applicationQuestionReviewItemValue()}
                />
            ) : (
                <>
                    <div
                        className='pageSubHeader'
                        style={{ paddingTop: '25px' }}
                    >
                        Land
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
                        <NumberBox
                            id='landSizeQuantity'
                            value={landSizeQuantity === '' ? undefined : Number(landSizeQuantity)}
                            onChange={(value) => set_landSizeQuantity(value ? value.toString() : '')}
                            label={label}
                            required={required}
                            format='#,##0.##'
                            width='220px'
                        />
                        <DropDownBox
                            id='landSizeUnit'
                            value={landSizeUnit}
                            onChange={(value) => set_landSizeUnit(value)}
                            required={required}
                            dataSource={landSizeUnits}
                            valueExpr='value'
                            displayExpr='display'
                            label='Units'
                            width='215px'
                            componentSpacing={DropDownBoxComponentSpacing.SmallSpacing}
                        />
                    </div>
                </>
            )}
        </>
    );
};
